import { Box, Paper } from '@mui/material';
import { useState } from 'react';
import StackablePageButtons from '@product-framework/components/StackablePageButtons';
import { IconLibrary } from '@product-framework/index';
import {
  useDataProvider,
  useLocalization,
  useSnackbar,
  useUserAccess,
} from '@ui-framework/index';
import { nanoid } from 'nanoid';
import SpecialSchedulesList from '../components/SpecialSchedulesList/index';
import SpecialScheduleForm from '../components/SpecialScheduleForm';
import { CURRENT_VIEW } from '../utils/constants';

function SpecialSchedules({ serviceProviderId, locationId = null }) {
  const snackbar = useSnackbar();
  const userAccess = useUserAccess();

  const { formatMessage } = useLocalization();
  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const { put, get, post, remove, getApiUrl } = useDataProvider(provider);

  const [selectedScheduleId, setSelectedScheduleId] = useState(null);
  const [listRefreshKey, setlistRefreshKey] = useState(nanoid());
  const [currentView, setCurrentView] = useState(CURRENT_VIEW.DEFAULT);
  const readOnly = userAccess.isUserReadonly();

  const commonParams = {
    snackbar,
    put,
    get,
    post,
    remove,
    getApiUrl,
    pageId: serviceProviderId,
  };

  const stackablePageButtons = [
    ...(currentView !== CURRENT_VIEW.EDIT_SCHEDULE
      ? [
          {
            label: formatMessage({
              id: 'CREATE_SPECIAL_SCHEDULE',
              defaultMessage: 'Create Special Schedule',
            }),
            Icon: IconLibrary.SpecialSchedule,
            variant: 'contained',
            permissionName: 'CAN_CREATE_SP_AVAILABILITY_SPECIAL_SCHEDULE',
            onClick: () => {
              setSelectedScheduleId(null);
              setCurrentView(CURRENT_VIEW.EDIT_SCHEDULE);
            },
          },
        ]
      : []),
    ...(currentView !== CURRENT_VIEW.DEFAULT
      ? [
          {
            label: formatMessage({
              id: 'LIST_DEFAULT_SCHEDULES',
              defaultMessage: 'List Special Schedules',
            }),
            Icon: IconLibrary.DefaultSchedules,
            variant: 'outlined',
            permissionName: 'CAN_VIEW_SP_AVAILABILITY_SPECIAL_SCHEDULE',
            onClick: () => {
              setSelectedScheduleId(null);
              setCurrentView(CURRENT_VIEW.DEFAULT);
            },
          },
        ]
      : []),
  ];

  const refreshListView = () => {
    setlistRefreshKey(nanoid());
  };

  return (
    <Box>
      <Box sx={{ mt: 2 }}>
        <StackablePageButtons
          backButton={false}
          buttons={stackablePageButtons}
        />
      </Box>

      {[CURRENT_VIEW.EDIT_SCHEDULE].includes(currentView) && (
        <Paper variant="outlined" sx={{ mb: 2, mt: 2 }}>
          <SpecialScheduleForm
            params={commonParams}
            currentView={currentView}
            setCurrentView={setCurrentView}
            selectedScheduleId={selectedScheduleId}
            setSelectedScheduleId={setSelectedScheduleId}
            refreshListView={refreshListView}
            readOnly={readOnly}
            locationId={locationId}
          />
        </Paper>
      )}
      {[CURRENT_VIEW.DEFAULT].includes(currentView) && (
        <Paper variant="outlined" sx={{ mb: 2, mt: 2 }}>
          <SpecialSchedulesList
            key={listRefreshKey}
            params={commonParams}
            currentView={currentView}
            setCurrentView={setCurrentView}
            selectedScheduleId={selectedScheduleId}
            setSelectedScheduleId={setSelectedScheduleId}
            refreshListView={refreshListView}
            readOnly={readOnly}
            locationId={locationId}
          />
        </Paper>
      )}
    </Box>
  );
}

export default SpecialSchedules;
